import type { LocationQueryValue } from 'vue-router';

type QueryValue = LocationQueryValue | LocationQueryValue[];

export const queryToString = (value: QueryValue | undefined, defaultValue = ''): string => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    const first = value[0];
    return typeof first === 'string' ? first : defaultValue;
  }
  return defaultValue;
};
